import {
  put, takeLatest,
} from 'redux-saga/effects';
import { createColor } from '~/_shared/components/colorPicker/colorPicker.helpers';
import type { ColorResult } from '~/_shared/components/colorPicker/colorPicker.types';
import { PRESET_COLORS_SECONDARY } from '~/_shared/constants/colors.constants';
import { type ProximityModel } from '~/_shared/types/proximity/proximity.types';
import {
  changeColorAlpha, getNextColorFromPresets,
} from '~/_shared/utils/colors/colors.helpers';
import { select } from '~/_shared/utils/saga/effects';
import { DEFAULT_PROXIMITY_BG_OPACITY } from '~/proximity/panel/form/proximityPanelForm.container';
import { MAP_SETTINGS_FETCH_DATA_SUCCESS } from '~/store/mapSettings/data/mapSettingsData.actionTypes';
import {
  MAP_SETTINGS_PROXIMITY_ADD_PROXIMITY, MAP_SETTINGS_PROXIMITY_MODIFY_PROXIMITY, MAP_SETTINGS_PROXIMITY_REMOVE_PROXIMITY,
} from '~/store/mapSettings/proximity/mapSettingsProximity.actionTypes';
import { proximitiesSelector } from '~/store/mapSettings/proximity/mapSettingsProximity.selectors';
import { setProximityColor } from './proximityTool.actionCreators';

export function* proximityToolSaga() {
  yield takeLatest([
    MAP_SETTINGS_PROXIMITY_ADD_PROXIMITY,
    MAP_SETTINGS_PROXIMITY_REMOVE_PROXIMITY,
    MAP_SETTINGS_PROXIMITY_MODIFY_PROXIMITY,
    MAP_SETTINGS_FETCH_DATA_SUCCESS,
  ], refreshProximityColors);
}

function* refreshProximityColors() {
  const proximities: ProximityModel[] = yield select(proximitiesSelector);
  const usedColors = proximities.map(item => item.styles.color);
  const newColor = getProximityColor(usedColors);
  yield put(setProximityColor(newColor));
}

export const getProximityColor = (usedColors: string[]): ColorResult => {
  const newColor = getNextColorFromPresets(usedColors, PRESET_COLORS_SECONDARY);
  let newColorResult = createColor(newColor);
  newColorResult = changeColorAlpha(newColorResult.rgba, DEFAULT_PROXIMITY_BG_OPACITY);

  return newColorResult;
};
